import { CommonModule } from "@angular/common";
import { Component, Inject, Input, ChangeDetectorRef, SimpleChanges, OnChanges, DoCheck, ChangeDetectionStrategy, OnDestroy } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { Subject, forkJoin } from "rxjs";
import { takeUntil, switchMap } from "rxjs/operators";
import { MatButtonModule } from "@angular/material/button";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatSnackBar, MatSnackBarModule } from "@angular/material/snack-bar";
import { MandatoryDocuments } from "src/app/iap/models/myProfile.model";
import { MyProfileService } from "src/app/iap/services/my-profile.service";
import { AuthenticationService } from "src/app/shared/auth/auth.service";
import { Helper } from "src/app/shared/common/helper";
import { v4 as uuidv4 } from "uuid";
import { CustomToasterComponent } from "src/app/shared/components/custom-toaster/custom-toaster.component";

@Component({
    selector: "app-onboarding-mandatory-documents",
    imports: [
        CommonModule,
        MatListModule,
        MatInputModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatSnackBarModule,
    ],
    templateUrl: "./onboarding-mandatory-documents.component.html",
    styleUrl: "./onboarding-mandatory-documents.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OnboardingMandatoryDocumentsComponent implements OnChanges, DoCheck, OnDestroy {
  @Input() agencyId: number;
  @Input() ContactInfo: any;
  @Input() CompanyInfo: any;
  constructor(
    private authService: AuthenticationService,
    private myProfileService: MyProfileService,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef,
    private snackBar: MatSnackBar
  ) {}

  fileToUpload: File | null = null;

  documentList: MandatoryDocuments[] = new Array(0); //stores the saved documents info
  documentPending: MandatoryDocuments[] = new Array(0); //store unsaved documents info
  formData: FormData[] = []; //store an array of files to be uploaded
  agentId: number;

  hasNewFileUploaded: boolean = false; //determine if the save button is disabled
  latestModified = {}; //store the last modified info
  fileIndexCounter: number = 0; //for generating document id
  toBeDeleted: MandatoryDocuments[] = []; //store files to be deleted when saved

  user: any;
  private lastContactInfoLength: number = 0; //track array length for mutation detection
  isSaving: boolean = false; //prevent concurrent saves
  private destroy$ = new Subject<void>();

  //isAuthorized: boolean = false;

  //@ViewChild("fileUpload1") fileUpload1: ElementRef;

  ngOnInit() {
    //this.isAuthorized = this.authService.hasRole("Agent");
    this.user = this.authService.getUserInfo();
    console.log("Contact info inside mandatory documents: ", this.ContactInfo);
    // this.myProfileService
    //   .getAgencyInformation(this.user.oid)
    //   .subscribe(agencyInfo => {
    //     this.agentId = agencyInfo.agencyId;

    //     this.getAllDocuments(this.agentId);
    //   });
    //populate documentList
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['ContactInfo'] && !changes['ContactInfo'].firstChange) {
      this.cdr.markForCheck();
    }
  }

  ngDoCheck() {
    // Detect array mutations by checking length and triggering change detection
    if (this.ContactInfo && Array.isArray(this.ContactInfo)) {
      if (this.lastContactInfoLength !== this.ContactInfo.length) {
        this.lastContactInfoLength = this.ContactInfo.length;
        this.cdr.markForCheck();
      }
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  refreshSigningOfficerCheck() {
    this.cdr.markForCheck();
  }

  public getAllDocuments = async (agentId): Promise<any> => {
    this.myProfileService.getMandatoryDocs(agentId).subscribe((results) => {
      if (results) {
        this.documentList = results;

        //create a copy of documentList
        this.documentList.map((document) => {
          this.documentPending.push(Object.assign({}, document));
        });

        this.sortByDate();

        this.fileIndexCounter = this.documentList.sort((a, b) => {
          return b.Document_Id - a.Document_Id;
        })[0].Document_Id;

        //this.agentId = this.documentList[0].agentId
      } else {
        console.log("server error! cannot fetch files from server");
      }
    });
  };

  displayFileName = (docType: any) => {
    let theFile = this.getFile(docType);
    return theFile.Document_Name.substring(
      theFile.Document_Name.indexOf("_") + 1
    );
  };

  sortByDate = () => {
    if (this.documentList.length > 0) {
      this.documentList.sort((b, a) => {
        return (
          Date.parse(a.Upload_Date.toString()) -
          Date.parse(b.Upload_Date.toString())
        );
      });
      //console.log(this.documentList);
      this.latestModified = {
        Uploaded_By: this.documentList[0].Uploaded_By,
        Upload_Date: new Date(this.documentList[0].Upload_Date).toDateString(),
      };
    } else {
      this.latestModified = undefined;
    }
  };

  //return the file if exist, undefined if otherwise
  getFile = (type: string) => {
    if (this.documentPending) {
      //console.log(this.documentList.find(obj => {return obj.document_Type == type}));
      return this.documentPending.find((obj) => {
        return obj.Document_Type == type;
      });
    } else return undefined;
  };

  //fires when a file is attached
  onFileSelected = async (
    type: string,
    event: { target: { files: File[] } }
  ) => {
    console.log("onFileSelected: ", type, event);

    if (!this.getFile(type)) {
      const self = this;
      const theFile: File = event.target.files[0];
      // Map internal types to display names
      const typeToDisplayName = {
        'BusRef1': 'Reference 1',
        'BusRef2': 'Reference 2',
        'Profile': 'Company Profile',
        'BusPlan': 'Business Plan',
        'Resume': 'Owner\'s Resume',
        'License': 'Copy of Registered Business Licence',
        'CnCert': 'China State Ministry Certification'
      };

      // Get the display name for the type
      const displayName = typeToDisplayName[type] || type;

      let filename = displayName + "_" + theFile.name;
      if (theFile) {
        let fd = new FormData();
        fd.append(type, theFile, filename);
        this.formData.push(fd);
      }
      //console.log(theFile);

      this.documentPending.push({
        agentId: this.agentId,
        Document_Type: type,
        Document_Name: filename,
        Document_Id: ++this.fileIndexCounter,
        Upload_Date: new Date(),
        Uploaded_By: self.authService.getUserInfo().name,
      });

      this.hasNewFileUploaded = true;
    }
  };

  //fires when save is clicked
  openSaveDialog = () => {
    //console.log(this.documentPending);
    console.log("Contact info inside mandatory documents: ", this.ContactInfo);
    console.log("Company info inside mandatory documents: ", this.CompanyInfo);
    const dialogRef = this.dialog.open(SaveDialogContentMandatoryDocuments, {
      data: {
        documentList: this.documentPending,
        save: this.saveDocs,
      },
    });
  };

  hasSigningOfficer = (): boolean => {
    if (!this.ContactInfo || !Array.isArray(this.ContactInfo)) {
      return false;
    }
    return this.ContactInfo.some((contact: any) => contact.userType === 'Signing Officer');
  };

  //when save dialogue is confirmed
  saveDocs = async (isSaveConfirmed: boolean): Promise<any> => {
    return new Promise((resolve, reject) => {
      if (this.isSaving) {
        console.warn("Save already in progress, ignoring duplicate request");
        reject(new Error("Save already in progress"));
        return;
      }

      let saveResult = null;
      let self = this;
      let companyData = {
        user_email: this.user.email,
        contactInfo: this.ContactInfo,
        companyInfo: this.CompanyInfo,
      };

      if (isSaveConfirmed) {
        this.isSaving = true;
        this.documentList = this.documentPending;
        this.hasNewFileUploaded = false;

        // Create array of file upload observables
        const fileUploads = this.formData.map((fd) =>
          this.myProfileService.uploadFile(fd, this.agencyId)
        );

        // Use forkJoin to wait for all file uploads to complete (excluding status update)
        const allRequests = [
          ...fileUploads,
          this.myProfileService.uploadMandatoryDocs(
            this.documentList,
            this.agencyId,
            this.toBeDeleted
          ),
          // this.myProfileService.insertProfilePic(
          //   this.ContactInfo,
          //   this.agencyId,
          //   this.ContactInfo.file
          // ),
          this.myProfileService.insertOnboardingInfo(
            companyData,
            this.agencyId
          ),
        ];

        // If there are no file uploads, ensure we still have requests to process
        if (allRequests.length === 0) {
          this.isSaving = false;
          console.error("No requests to process");
          reject(new Error("No requests to process"));
          return;
        }

        forkJoin(allRequests)
          .pipe(
            switchMap(() => {
              // Update onboarding status only after all other requests complete
              return this.myProfileService.updateAgencyOnboardingStatus(
                this.agencyId,
                "true",
                "step1"
              );
            }),
            takeUntil(this.destroy$)
          )
          .subscribe(
            (results) => {
              console.log("All operations completed successfully, onboarding status updated:", results);
              this.isSaving = false;
              this.formData = [];
              this.toBeDeleted = [];
              resolve(results);
              // Clear sessionStorage drafts
              try {
                const keysToRemove = [];
                for (let i = 0; i < sessionStorage.length; i++) {
                  const key = sessionStorage.key(i);
                  if (key && key.startsWith('onboarding_')) {
                    keysToRemove.push(key);
                  }
                }
                keysToRemove.forEach(key => sessionStorage.removeItem(key));
              } catch (e) {
                console.error('Error clearing session storage drafts', e);
              }
              // Refresh the page after successful submission
              window.location.reload();
            },
            (error) => {
              console.error("Error during save operation:", error);
              this.isSaving = false;
              // Restore state in case of error
              this.hasNewFileUploaded = true;
              this.documentList = [];
              
              // Show error message to user
              this.snackBar.openFromComponent(CustomToasterComponent, {
                          data: { title: 'ERROR', message: 'An error occurred while saving. Please try again', type: 'error' },
                          duration: 3000,
                          horizontalPosition: 'right',
                          verticalPosition: 'top',
                          panelClass: ['custom-toast-panel']
              });
              
              reject(error);
            }
          );
      } else {
        reject(new Error("Save not confirmed"));
      }
    });
  };

  //Add documents to toBeDeleted array
  deleteDoc = (documentType: string) => {
    let foundDoc = this.getFile(documentType);
    if (foundDoc) {
      //console.log(foundDoc);
      this.documentPending.splice(
        this.documentPending.findIndex(
          (doc) => doc.Document_Type == documentType
        ),
        1
      );
      let flag = false;
      for (let i = this.formData.length - 1; i >= 0; i--) {
        if (this.formData[i].has(documentType)) {
          this.formData.splice(i, 1);
          flag = true;
        }
      }
      if (!flag) {
        this.toBeDeleted.push(foundDoc);
      }
      this.hasNewFileUploaded = true;
      //console.log(this.documentPending);
    }
  };

  onReset = () => {
    this.documentPending = this.documentList;
    this.hasNewFileUploaded = false;
    this.toBeDeleted = [];
  };

  openDoc = (documentType) => {
    let doc: MandatoryDocuments = this.getFile(documentType);
    let docUploaded = this.documentList.find((theDoc) => {
      return theDoc.Document_Name === doc.Document_Name;
    });
    //console.log(docUploaded);
    if (docUploaded) {
      this.myProfileService
        .downloadFile(doc.agentId, doc.Document_Name)
        .subscribe((response) => {
          let downloadedFile = new File([response], doc.Document_Name, {
            type: response.type,
          });

          var fileExtension = doc.Document_Name.substr(
            doc.Document_Name.lastIndexOf(".") + 1
          );

          var contentType = Helper.GetContentType(fileExtension);

          var blob = new Blob([downloadedFile], {
            type: contentType,
          });

          // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          //   window.navigator.msSaveOrOpenBlob(blob);
          //   return;
          // }

          let link = document.createElement("a");
          let url = window.URL.createObjectURL(blob);
          link.href = url;
          link.download = this.displayFileName(documentType);
          console.log(doc.Document_Name);

          //if (fileExtension != "pdf"){
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          window.URL.revokeObjectURL(url);
          //}
          //else {
          // setTimeout(() => window.open(link.href), 500);
          //}
        });
    } else {
      var fileExtension = doc.Document_Name.substring(
        doc.Document_Name.lastIndexOf(".") + 1
      );
      var contentType = Helper.GetContentType(fileExtension);

      this.formData.map((fd) => {
        if (fd.has(documentType)) {
          var theFile = fd.get(documentType);

          var blob = new Blob([theFile], {
            type: contentType,
          });

          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = doc.Document_Name;
          document.body.appendChild(link);

          setTimeout(() => window.open(link.href), 500);
        }
      });
    }
  };
}

@Component({
    selector: "save-dialog-content-mandatory-documents",
    templateUrl: "../../../../../../../src/app/shared/components/dialog/saveDialog/save-dialog-content-mandatory-documents.html",
    styleUrl: "../../../../../../../src/app/shared/components/dialog/saveDialog/save-dialog-content-mandatory-documents.scss",
    imports: [CommonModule, MatDialogModule, MatButtonModule]
})
export class SaveDialogContentMandatoryDocuments {
  docName: string[] = new Array<string>(0);
  isSaveClicked: boolean = false;
  saveResult: any = undefined;
  isSaving: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<SaveDialogContentMandatoryDocuments>
  ) {
    //console.log(data);
    for (let doc of data.documentList) {
      this.docName.push(
        doc.Document_Name.substr(doc.Document_Name.indexOf("_") + 1)
      );
    }
  }

  onSaveConfirmed = async () => {
    if (this.isSaving) {
      console.warn("Save already in progress, ignoring duplicate request");
      return;
    }
    this.isSaving = true;
    try {
      this.saveResult = await this.data.save(true);
      this.isSaveClicked = true;
    } catch (error) {
      console.error("Save failed:", error);
      this.isSaving = false;
      this.isSaveClicked = false;
      // Close the dialog so the error snackbar is visible
      this.dialogRef.close();
    }
  };
}
